import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/react-hooks';

import App from './App';
import { client } from './apolloClient';
import * as serviceWorker from './serviceWorker';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import 'antd/dist/antd.css';

export const isProd = process.env.REACT_APP_ENV === 'production';

Bugsnag.start({
  apiKey: 'e992744260965489f19b9f2386d2121f',
  plugins: [new BugsnagPluginReact()],
  appVersion: "4.0.16"
})

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)

ReactDOM.render(
  <ErrorBoundary>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
